import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStatusGlowPink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    viewBox="0 0 470 152"
    fill="none"
    {...props}
  >
    <g clipPath="url(#protect-status-glow-pink-clip)">
      <g filter="url(#protect-status-glow-pink-blur)">
        <ellipse cx={241} cy={-13} rx={415} ry={73} fill="#FFDDE3" />
      </g>
    </g>
    <defs>
      <filter
        id="protect-status-glow-pink-blur"
        x={-274}
        y={-186}
        width={1030}
        height={346}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={50}
          result="protect-status-glow-pink-blur-effect"
        />
      </filter>
      <clipPath id="protect-status-glow-pink-clip">
        <rect width={470} height={152} fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStatusGlowPink;
